"use client";

import { Select } from "antd";
import { useState, useEffect } from "react";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import PrimaryOutlineButton from "../PrimaryOutlineButton";
import PrimaryButton from "../PrimaryButton";

export default function TargetModal({
  target,
  isOpen,
  onClose,
  onSubmit,
  mode = "set",
}) {
  const [duration, setDuration] = useState("1 Month");
  const [amount, setAmount] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    // For "set" mode always start blank; for "update" prefill.
    setAmount(mode === "update" ? String(target ?? "") : "");
    setDuration("1 Month");
  }, [isOpen, mode, target]);

  const durations = ["1 Month", "3 Months", "6 Months", "1 Year"].map((d) => ({
    label: d,
    value: d,
  }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Changed property name from "target" to "amount" to match what the parent component expects
    const success = await onSubmit({ amount, duration });
    if (success) {
      setAmount("");
      setDuration("1 Month");
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="popup-container">
      <div className="flex flex-col justify-evenly items-center w-[450px] sm:w-[550px] bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] popup p-6">
        <h2 className="text-[16px] md:text-[18px] font-[700] text-[#000000] font-poppins mb-2">
          {mode === "set" ? "Set Target" : "Update Target"}
        </h2>
        <p className="text-center text-[12px] md:text-[14px] font-[400] text-[#8C8C8C] font-poppins mb-8">
          You can set a target for a specific duration.
          <br />
          The target can be adjusted at any time.
        </p>

        <form onSubmit={handleSubmit} className="w-full">
          <div className="w-full flex justify-between items-center mb-6">
            <div className="w-[59%] flex flex-col justify-start items-start gap-3">
              <label className="text-[12px] md:text-[14px] font-[400] text-[#303030] font-poppins">
                Add Amount
              </label>
              <div className="w-full relative">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[14px] md:text-[16px] font-[500] text-[#303030] font-poppins">
                  $
                </span>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="w-full pl-7 pr-3 py-2 border border-[#D9D9D9] rounded-[10px] focus:outline-none text-[14px] md:text-[16px] font-[500] text-[#303030] font-poppins"
                  placeholder="2000"
                  required
                />
              </div>
            </div>

            <div className="w-[39%] flex flex-col justify-start items-start gap-3">
              <label className="text-[12px] md:text-[14px] font-[400] text-[#303030] font-poppins">
                Duration
              </label>
              <div className="w-full border border-[#D9D9D9] rounded-[10px] overflow-hidden">
                <Select
                  value={duration}
                  className={
                    "text-[14px] md:text-[16px] font-[500] text-[#303030] font-poppins h-[40px] w-full [&_.ant-select-selector]:!border-none [&_.ant-select-selector]:!outline-none [&_.ant-select-selector]:!shadow-none"
                  }
                  style={{
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                  suffixIcon={<DownArrow />}
                  options={durations}
                  defaultValue={duration}
                  onChange={(e) => setDuration(e)}
                  dropdownMatchSelectWidth={false}
                />
              </div>
            </div>
          </div>

          <div className="w-full flex justify-center items-center">
            <div className="flex justify-center items-center gap-3 w-[70%]">
              <PrimaryOutlineButton
                label={"Cancel"}
                type="button"
                className={
                  "w-full text-[14px] md:text-[16px] font-[500] font-poppins px-2 py-2 h-[40px] sm:h-[40px] md:h-[45px] rounded-[10px] whitespace-nowrap"
                }
                onClick={onClose}
              />
              <PrimaryButton
                className={
                  "w-full px-2 py-2 sm:h-[40px] md:h-[45px] rounded-[10px] text-[14px] md:text-[16px] font-[500] font-poppins"
                }
                label={mode === "set" ? "Set" : "Update"}
                type={"submit"}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}